import type { HasTagCondition } from "@redotech/redo-flows-common/rules/schemas";
import {
  QueryOperator,
  RuleConditionType,
} from "@redotech/redo-flows-common/rules/types";
import { SPAM_TAG } from "@redotech/redo-support-tags-common/conversation-tag-record";
import { SPAM_TAG_NAME } from "@redotech/redo-support-tags-common/system-tag-names";

/**
 * Passes unless the ticket is spam. Mail sync and the inbox tag spam `spam`;
 * `SPAM` is the older system name some accounts still carry.
 */
export function notSpamCondition(): HasTagCondition {
  return {
    conditionType: RuleConditionType.HAS_TAG,
    tags: [SPAM_TAG_NAME, SPAM_TAG],
    queryOperator: QueryOperator.IS_NOT,
  };
}
